export default Object.freeze({
  CUSTOMER_PROFILE: 'customer',
  CONVERSATION: 'conversation',
  USER: 'user',
});



// WEBPACK FOOTER //
// ./src/scripts/domain/models/search/hit_types.js